// Primary colors - Green shades for Islamic financing theme
export const colors = {
  // Main brand colors - Professional green
  primary: {
    50: '#f0fdf4',
    100: '#dcfce7',
    200: '#bbf7d0',
    300: '#86efac',
    400: '#4ade80',
    500: '#22c55e',
    600: '#16a34a',
    700: '#15803d',
    800: '#1a4a1a', // Main brand color matching homepage
    900: '#14532d',
  },
  
  // Secondary accent color (soft gold/amber for Islamic financing)
  secondary: {
    50: '#fefce8',
    100: '#fef9c3',
    200: '#fef08a',
    300: '#fde047',
    400: '#facc15',
    500: '#f7b007', // Subtle gold
    600: '#d97706',
    700: '#b45309',
    800: '#92400e',
    900: '#78350f',
  },

  // Accent color (teal with 786 reference)
  accent: {
    50: '#f0fdfa',
    100: '#ccfbf1',
    200: '#99f6e4',
    300: '#5eead4',
    400: '#2dd4bf',
    500: '#17867d', // Incorporating 786
    600: '#0d7868',
    700: '#115e59',
    800: '#134e4a',
    900: '#042f2e',
  },

  // Neutral colors for text and backgrounds
  neutral: {
    50: '#f8fafc',
    100: '#f1f5f9',
    200: '#e2e8f0',
    300: '#cbd5e1',
    400: '#94a3b8',
    500: '#647886', // Incorporating 786
    600: '#475569',
    700: '#334155',
    800: '#1e293b',
    900: '#0f172a',
  },

  // Success colors (for positive financial indicators)
  success: {
    50: '#f0fdf4',
    100: '#dcfce7',
    200: '#bbf7d0',
    300: '#86efac',
    400: '#4ade80',
    500: '#22c55e',
    600: '#16a34a',
    700: '#15803d',
  },

  // Warning colors (for notifications)
  warning: {
    50: '#fff7ed',
    100: '#ffedd5',
    200: '#fed7aa',
    300: '#fdba74',
    400: '#fb923c',
    500: '#f97316',
    600: '#ea580c',
    700: '#c2410c',
  },
};

// Semantic color mapping
export const semanticColors = {
  // Background colors - Lighter and more modern
  background: {
    primary: colors.primary[800], // Using main brand color
    secondary: colors.primary[600],
    light: colors.neutral[50],
    dark: colors.neutral[800],
    accent: colors.accent[500],
  },
  
  // Text colors
  text: {
    primary: colors.neutral[800],
    secondary: colors.neutral[600],
    light: colors.neutral[50],
    muted: colors.neutral[400],
    accent: colors.accent[600],
  },
  
  // Button colors - More vibrant and engaging
  button: {
    primary: {
      background: colors.primary[800], // Using main brand color
      hover: colors.primary[700],
      text: colors.neutral[50],
    },
    secondary: {
      background: colors.secondary[400],
      hover: colors.secondary[500],
      text: colors.neutral[900],
    },
    accent: {
      background: colors.accent[500],
      hover: colors.accent[600],
      text: colors.neutral[50],
    },
  },
  
  // Link colors
  link: {
    default: colors.primary[800], // Using main brand color
    hover: colors.primary[700],
    visited: colors.primary[700],
  },
  
  // Border colors
  border: {
    light: colors.neutral[200],
    default: colors.neutral[300],
    dark: colors.neutral[400],
  },
};

// Gradients - Softer and more modern
export const gradients = {
  primary: `linear-gradient(to right, ${colors.primary[600]}, ${colors.primary[800]})`,
  secondary: `linear-gradient(to right, ${colors.secondary[400]}, ${colors.secondary[500]})`,
  accent: `linear-gradient(to right, ${colors.accent[400]}, ${colors.accent[500]})`,
  header: `linear-gradient(to right, ${colors.primary[800]}, ${colors.accent[500]})`,
}; 